import { create } from 'zustand';

const useSidebarStore = create((set) => ({
  collapsed: localStorage.getItem('sidebar_collapsed') === 'true',
  toggle: () =>
    set((s) => {
      const next = !s.collapsed;
      localStorage.setItem('sidebar_collapsed', String(next));
      return { collapsed: next };
    }),
}));

export default useSidebarStore;
